<template>
<div class="w-full">
  <div class="flex space-x-2 items-start" v-if="pttType == 'normal'">
    <div class="shrink-0 w-2 flex h-14">
      <sound-meter ref="soundMeter" id="me" :stream="stream" class="w-full" :muted="!isMicrophoneOn"
                   v-on:speaking="onSpeaking()"></sound-meter>
    </div>
    <div class="grow">
      <div class="flex space-x-1 h-14">
        <button @mousedown="openPTT()" @mouseup="closePTT()" class="btn grow w-full "
                :class="isMicrophoneOn ? 'speaking' : 'btn-primary'">
          <div class="h-full inline-flex items-center space-x-2" v-if="isMicrophoneOn == false">
            <!-- Microphone icon -->
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                 class="w-5 sm:w-5 h-5 sm:h-5 -ml-1">
              <path d="M8.25 4.5a3.75 3.75 0 117.5 0v8.25a3.75 3.75 0 11-7.5 0V4.5z" />
              <path
                d="M6 10.5a.75.75 0 01.75.75v1.5a5.25 5.25 0 1010.5 0v-1.5a.75.75 0 011.5 0v1.5a6.751 6.751 0 01-6 6.709v2.291h3a.75.75 0 010 1.5h-7.5a.75.75 0 010-1.5h3v-2.291a6.751 6.751 0 01-6-6.709v-1.5A.75.75 0 016 10.5z" />
            </svg>
            <div class="text-left">
              <div class="font-bold"> Push-to-talk</div>
              <div class="font-medium text-sm"> or press the spacebar</div>
            </div>
          </div>
          <div class="h-full inline-flex justify-start items-center space-x-2 text-white" v-if="isMicrophoneOn">
            <!-- Microphone icon -->
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                 class="w-5 sm:w-5 h-5 sm:h-5 -ml-1">
              <path d="M8.25 4.5a3.75 3.75 0 117.5 0v8.25a3.75 3.75 0 11-7.5 0V4.5z" />
              <path
                d="M6 10.5a.75.75 0 01.75.75v1.5a5.25 5.25 0 1010.5 0v-1.5a.75.75 0 011.5 0v1.5a6.751 6.751 0 01-6 6.709v2.291h3a.75.75 0 010 1.5h-7.5a.75.75 0 010-1.5h3v-2.291a6.751 6.751 0 01-6-6.709v-1.5A.75.75 0 016 10.5z" />
            </svg>
            <div class="text-2xl sm:text-base font-bold"> Mic is open </div>
          </div>
        </button>
      </div>
      <div class="mt-2 flex justify-between">
        <div>
          Keep mic open
        </div>
        <div>
          <div class="form-switch ml-2" @click="isMicrophoneLockedOn ? activatePTT() : keepMicOpen()">
            <input type="checkbox" v-model="isMicrophoneLockedOn">
            <i></i>
          </div>

        </div>
      </div>
      <div class="grid-cols-2 hidden">
        <div class="sm:block hidden text-center mt-2 text-red-500"
             v-if="isMicrophoneOn == true && isPTTPressed == false">
          &nbsp;
        </div>
        <div class="sm:block hidden text-center mt-2 text-green-500" v-if="isPTTPressed"> Speaking...</div>
      </div>
    </div>

  </div>
  <!-- Push to talk for mobile -->
  <div class="flex py-0 w-40 fixed bottom-2 mx-auto md:right-0 inset-x-0 z-80 lg:hidden" v-if="pttType == 'mobile'">
    <button type="button"
            class="rounded-xl rounded-r-none md:rounded-md py-2 text-center cursor-pointer btn btn-primary w-full h-20 sm:h-16 lg:h-14 flex justify-center items-center select-none"
            id="PTTButtonSecond" :class="isMicrophoneOn ? 'speaking' : 'btn-primary'"
            @mousedown="openPTT()" @mouseup="closePTT()"
            @touchstart="openPTT()" @touchend="closePTT()"
            >
      <div class="waiting-to-speak inline-flex items-center space-y-2 flex-col" v-if="isMicrophoneOn == false">
        <!-- Microphone icon -->
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-5 h-5">
          <path d="M8.25 4.5a3.75 3.75 0 117.5 0v8.25a3.75 3.75 0 11-7.5 0V4.5z" />
          <path
            d="M6 10.5a.75.75 0 01.75.75v1.5a5.25 5.25 0 1010.5 0v-1.5a.75.75 0 011.5 0v1.5a6.751 6.751 0 01-6 6.709v2.291h3a.75.75 0 010 1.5h-7.5a.75.75 0 010-1.5h3v-2.291a6.751 6.751 0 01-6-6.709v-1.5A.75.75 0 016 10.5z" />
        </svg>
        <div class="text-xl font-bold"> PTT </div>
      </div>
      <div class="py-3 text-xl" v-if="isMicrophoneOn">
        <div class="font-bold">Speak now</div>
      </div>
    </button>
    <button type="button"
            class="hidden sm:flex py-2 text-center text-xs rounded-l-none cursor-pointer btn justify-center items-center select-none px-2"
            :class="isMicrophoneLockedOn ? 'bg-blue-300 text-white' : 'btn-secondary'"
            @click="isMicrophoneLockedOn ? activatePTT() : keepMicOpen()">
      <div class="" v-if="isMicrophoneLockedOn">
        <!-- lock icon -->
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-6 h-6">
          <path fill-rule="evenodd"
                d="M12 1.5a5.25 5.25 0 00-5.25 5.25v3a3 3 0 00-3 3v6.75a3 3 0 003 3h10.5a3 3 0 003-3v-6.75a3 3 0 00-3-3v-3c0-2.9-2.35-5.25-5.25-5.25zm3.75 8.25v-3a3.75 3.75 0 10-7.5 0v3h7.5z"
                clip-rule="evenodd" />
        </svg>
      </div>
      <div class="flex py-2 flex-col items-center justify-center" data-tippy-content="Keep mic open" v-if="isMicrophoneLockedOn == false">
        <!-- lock off icon -->
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-6 h-6">
          <path
            d="M18 1.5c2.9 0 5.25 2.35 5.25 5.25v3.75a.75.75 0 01-1.5 0V6.75a3.75 3.75 0 10-7.5 0v3a3 3 0 013 3v6.75a3 3 0 01-3 3H3.75a3 3 0 01-3-3v-6.75a3 3 0 013-3h9v-3c0-2.9 2.35-5.25 5.25-5.25z" />
        </svg>
      </div>
    </button>

  </div>
  <div v-if="pttType == 'overlay'">
    <button type="button" class="rounded-xl md:rounded-md py-2 text-center cursor-pointer btn btn-primary w-full flex justify-center items-center select-none"
            :class="isMicrophoneOn ? 'speaking' : 'btn-primary'"
            @mousedown="openPTT()" @mouseup="closePTT()"
            @touchstart="openPTT()" @touchend="closePTT()">
      <div class="" v-if="isMicrophoneOn == false && isMicrophoneLockedOn == false">
        <div class="font-bold">HOLD</div>
      </div>
      <div class="py-3" v-if="isMicrophoneOn == true || isMicrophoneLockedOn == true">
        <div class="font-bold">SPEAK</div>
      </div>
    </button>
  </div>
</div>
</template>
<script>
export default {
  props: {
    pttType: {
      type: String,
      default: 'normal'
    },
  },
  data() {
    return {
      stream: null,
      isMicrophoneOn: false,
      isPTTPressed: false,
      speakingTimeout: null,
      isMicrophoneLockedOn: false,
    }
  },
  methods: {
    closePTT() {
      this.isMicrophoneOn = false
      window.manager.toggleLocalAudio(this.isMicrophoneOn);
      this.updateOtherPTTStatus()
      this.isMicrophoneLockedOn = false
    },
    openPTT() {
      this.isMicrophoneOn = true
      window.manager.toggleLocalAudio(this.isMicrophoneOn);
      this.updateOtherPTTStatus()
    },
    keepMicOpen() {
      this.isMicrophoneLockedOn = true
      this.isMicrophoneOn = true
      window.manager.toggleLocalAudio(this.isMicrophoneOn);
      this.updateOtherPTTStatus()
    },
    activatePTT() {
      this.isMicrophoneLockedOn = false
      this.isMicrophoneOn = false
      window.manager.toggleLocalAudio(this.isMicrophoneOn);
      this.updateOtherPTTStatus()
    },

    updateOtherPTTStatus() {
      if (vm.$refs.videoPlayer && vm.$refs.videoPlayer.$refs.pttOverlay) {
        const ref = vm.$refs.videoPlayer.$refs.pttOverlay;
        ref.isMicrophoneOn = this.isMicrophoneOn;
        ref.isMicrophoneLockedOn = this.isMicrophoneLockedOn;
        if (this.isMicrophoneOn == false){
          ref.isMicrophoneLockedOn = false
        }
      }
      if (vm.$refs.pttMobile) {
        vm.$refs.pttMobile.isMicrophoneOn = this.isMicrophoneOn;
        vm.$refs.pttMobile.isMicrophoneLockedOn = this.isMicrophoneLockedOn;
        if (this.isMicrophoneOn == false){
          vm.$refs.pttMobile.isMicrophoneLockedOn = false
        }
      }
      if (vm.$refs.ptt) {
        vm.$refs.ptt.isMicrophoneOn = this.isMicrophoneOn;
        vm.$refs.ptt.isMicrophoneLockedOn = this.isMicrophoneLockedOn;
        if (this.isMicrophoneOn == false){
          vm.$refs.ptt.isMicrophoneLockedOn = false
        }
      }
    },
    addStream(stream) {
      this.stream = stream;
    },
    onSpeaking() {
      // make button slightly bigger
      this.isPTTPressed = true;
      clearTimeout(this.speakingTimeout);
      this.speakingTimeout = setTimeout(() => {
        this.isPTTPressed = false;
        this.speakingTimeout = null;
      }, 200);
    },
  },
  mounted() {
    let spaceBarDown = false;
    document.addEventListener("keydown", (ev) => {
      // if its writing in any input or textarea disable this listener
      if (document.activeElement.tagName === 'INPUT') return;
      if (document.activeElement.tagName === 'TEXTAREA') return;

      if (ev.keyCode === 32) { // spacebar
        // do not go down when hitting spacebar
        ev.preventDefault();
        // variable to avoid repeatingly unmuting spacebar
        if (spaceBarDown) return;
        spaceBarDown = true;
        this.isMicrophoneOn = true
        window.manager.toggleLocalAudio(this.isMicrophoneOn);
      }
    });

    document.addEventListener("keyup", (ev) => {
      // if its writing in any input or textarea disable this listener
      if (document.activeElement.tagName === 'INPUT') return;
      if (document.activeElement.tagName === 'TEXTAREA') return;

      if (ev.keyCode === 32) { // spacebar
        // do not go down when hitting spacebar
        ev.preventDefault();
        // variable to avoid repeatingly unmuting spacebar
        if (spaceBarDown) {
          this.isMicrophoneOn = false
          spaceBarDown = false;
          window.manager.toggleLocalAudio(this.isMicrophoneOn);
        };
      }
    });
  }
}
</script>
<style>
    .speaking {
    background: #17d200;
    }

    .speaking {
    color: white;
    background: #17d200 !important;
    transform: scale(1) !important;
    }</style>